import { render, staticRenderFns } from "./ConversionSummaryInfo.vue?vue&type=template&id=531190c2&scoped=true&"
import script from "./ConversionSummaryInfo.vue?vue&type=script&lang=ts&"
export * from "./ConversionSummaryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConversionSummaryInfo.vue?vue&type=style&index=0&id=531190c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531190c2",
  null
  
)

export default component.exports